define('plugin/membership/view/MembershipFilterView',['require','lib/view/LayoutView','plugin/membership/view/MembershipFilterItemView','plugin/membership/view/MembershipFilterCollectionView'],function (require) {

    // var Marionette = require('marionette');
    var Parent = require('lib/view/LayoutView');
    var MembershipFilterItemView = require('plugin/membership/view/MembershipFilterItemView');
    var MembershipFilterCollectionView = require('plugin/membership/view/MembershipFilterCollectionView');

    /**
     * Membership filter view
     *
     * @class MembershipFilterView
     */
    return Parent.extend({

        namespace: 'membership',

        template: '#membership_filter_view',
        // childView: MembershipFilterItemView,
        // childViewContainer: '#sb_membership_filter_service_container',
        childEvents: {
            'filterChanged': 'onFilterChanged'
        },
        regions: {
            'services': '#sb_membership_filter_service_container',
            'products': '#sb_membership_filter_product_container',
            'paidAttributes': '#sb_membership_filter_attribute_container',
        },
        // childViewOptions: function (model, index) {
        //     var filter = this.getOption('filterData');
        //     if (filter && filter.services) {
        //         return {
        //             'checked': _.indexOf(filter.services, model.get('id')) !== -1
        //         };
        //     }
        //     return {};
        // },

        onFilterChanged: function () {
            var url = this._buildUrl();
            Backbone.history.navigate(url, {
                trigger: 1
            });
        },

        _buildUrl: function () {
            var serviceItemViews = this.services.currentView.children;

            var services = [];
            serviceItemViews.each(function (view) {
                if (view.isChecked()) {
                    services.push(view.model.get('id'));
                }
            });

            var url = 'membership';
            if (services.length) {
                url += '/services/' + services.join(',');
            }

            return url;
        },

        serializeData: function () {
            var filter = this.getOption('filterData');

            // var hasChecked = filter && filter.services;
            return _.extend(Parent.prototype.serializeData.apply(this), {
                // hasChecked: hasChecked,
                namespace: this.namespace
            });
        },

        onRender: function () { 
            this.showChildView('services', new MembershipFilterCollectionView({
                collection: this.getOption('collection'),
                filterData: this.getOption('filterData'),
                field: 'services'
            }));

            if (this.supportsProducts()) {
                this.showChildView('products', new MembershipFilterCollectionView({
                    collection: this.getOption('productCollection'),
                    filterData: this.getOption('filterData'),
                    field: 'products'
                }));
            }

            if (this.supportsPaidAttributes()) {
                this.showChildView('paidAttributes', new MembershipFilterCollectionView({
                    collection: this.getOption('attributeCollection'),
                    filterData: this.getOption('filterData'),
                    field: 'products'
                }));
            }
        },

        supportsProducts: function () {
            return false
        },

        supportsPaidAttributes: function () {
            return false
        },



    });

});
